import React from 'react'
import '../CSS/Education.css'

const Education = () => {
  return (
    <div className='education'>
        <div className="education-main">
            <div className="education-title">
                <h1>Education</h1>
                <input type="text" />
            </div>
            <div className="education-text">
                <h1>Software Engineering</h1>
                <h4>Gia Dinh University</h4>
                <p>2021-2024</p>
                <p>GPA: 3.25/4.0</p>
            </div>
        </div>
    </div>
  )
}

export default Education
